import { how, benefits } from '../content.js'

export default function How() {
  return (
    <section className="section" id="how">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">How we get you live</span>
          <h2>{how.title}</h2>
        </div>
        <ol className="steps">
          {how.steps.map((s, i) => (
            <li key={s.title}>
              <span className="step-num">{i + 1}</span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </li>
          ))}
        </ol>
        <div className="stats benefits">
          {benefits.map((b) => (
            <div key={b.label} className="stat"><b className="grad-pp">{b.value}</b><span>{b.label}</span></div>
          ))}
        </div>
      </div>
    </section>
  )
}
